export const UserCommentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M12.582,11.3A6.838,6.838,0,0,0,15.5,12.43c0,.57,0,2.57,0,3.07.5-.5,3.5-3,4-3.461a6.015,6.015,0,0,0,4-5.539A6.265,6.265,0,0,0,17,.5c-5.25,0-9.027,5.751-4.417,10.8Z"
        fill="#00e6ca"
      />
      <path
        d="M17,2.5a6.373,6.373,0,0,1,6.41,5,5.613,5.613,0,0,0,.09-1A6.265,6.265,0,0,0,17,.5c-3.949,0-7.064,3.253-6.4,7.012A6.365,6.365,0,0,1,17,2.5Z"
        fill="#c4f0eb"
      />
      <path d="M15.5,14.43h0v.182C15.5,14.541,15.5,14.48,15.5,14.43Z" fill="#c4f0eb" />
      <path
        d="M.5,23.5a8.719,8.719,0,0,1,.7-3.322c.49-.981,2.539-1.661,5.111-2.613.695-.258.581-2.074.273-2.413a5.127,5.127,0,0,1-1.336-3.978A3.354,3.354,0,0,1,8.5,7.5a3.354,3.354,0,0,1,3.256,3.674,5.127,5.127,0,0,1-1.336,3.978c-.308.339-.422,2.155.273,2.413,2.572.952,4.621,1.632,5.111,2.613a8.719,8.719,0,0,1,.7,3.322Z"
        fill="#c4f0eb"
      />
      <path
        d="M8.5,7.5a3.354,3.354,0,0,0-3.256,3.674A5.127,5.127,0,0,0,6.58,15.152c.308.339.422,2.155-.273,2.413C3.734,18.517,1.686,19.2,1.2,20.178A8.719,8.719,0,0,0,.5,23.5h8Z"
        fill="#f8fafc"
      />
      <path
        d="M.5,23.5a8.719,8.719,0,0,1,.7-3.322c.49-.981,2.539-1.661,5.111-2.613.695-.258.581-2.074.273-2.413a5.127,5.127,0,0,1-1.336-3.978A3.354,3.354,0,0,1,8.5,7.5a3.354,3.354,0,0,1,3.256,3.674,5.127,5.127,0,0,1-1.336,3.978c-.308.339-.422,2.155.273,2.413,2.572.952,4.621,1.632,5.111,2.613a8.719,8.719,0,0,1,.7,3.322Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.979,12.034a6.828,6.828,0,0,0,1.521.4c0,.57,0,2.57,0,3.07.5-.5,3.5-3,4-3.461a6.015,6.015,0,0,0,4-5.539A6.265,6.265,0,0,0,17,.5a6.329,6.329,0,0,0-6.467,5.393"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25,6.25a.249.249,0,0,1,.25.25h0a.249.249,0,0,1-.25.25h0A.25.25,0,0,1,14,6.5h0a.25.25,0,0,1,.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={14.25}
        y1={6.25}
        x2={14.25}
        y2={6.25}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17,6.25a.25.25,0,0,1,.25.25h0a.25.25,0,0,1-.25.25h0a.25.25,0,0,1-.25-.25h0A.25.25,0,0,1,17,6.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={17}
        y1={6.25}
        x2={17}
        y2={6.25}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.75,6.25A.25.25,0,0,1,20,6.5h0a.25.25,0,0,1-.25.25h0a.25.25,0,0,1-.25-.25h0a.25.25,0,0,1,.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={19.75}
        y1={6.25}
        x2={19.75}
        y2={6.25}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
